var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"view-page-offline",attrs:{"limit":"small"}},[_c('blank-state',{attrs:{"title":"You are offline","description":"Please check you internet connection to use this app. This page will automatically refresh when you're back online."}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e4f357","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageOffline.vue
// module id = 356
// module chunks = 0